import { SERVICES } from "@/lib/api";

const Marquee = () => {
  const items = [...SERVICES, ...SERVICES].map((s) => s.key);
  return (
    <div data-testid="services-marquee" className="bg-black border-y border-[#2e2e2e] py-8 overflow-hidden">
      <div className="marquee-track">
        {items.map((label, idx) => (
          <span key={idx} className="font-['Anton'] text-stroke text-6xl md:text-8xl uppercase mx-12 inline-block">
            {label} <span className="text-[#e10600]" style={{ WebkitTextStroke: 0 }}>•</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
